/**
 * @generated SignedSource<<3064973a3b9e9dd1439738fc29b3b1a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HotelSource = "ETG" | "TEDO";
import { FragmentRefs } from "relay-runtime";
export type HotelEditMain_hotel$data = {
  readonly aboutLocation: string | null;
  readonly aboutLocationText: {
    readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_text" | "useEditorJsField_text">;
  } | null;
  readonly city: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly description: string | null;
  readonly descriptionText: {
    readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_text" | "useEditorJsField_text">;
  } | null;
  readonly features: ReadonlyArray<string> | null;
  readonly id: string;
  readonly location: {
    readonly lat: number;
    readonly lng: number;
  } | null;
  readonly name: string;
  readonly reviews: ReadonlyArray<string> | null;
  readonly source: HotelSource | null;
  readonly stars: number | null;
  readonly userEdited: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMainGeneral_hotel">;
  readonly " $fragmentType": "HotelEditMain_hotel";
};
export type HotelEditMain_hotel$key = {
  readonly " $data"?: HotelEditMain_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMain_hotel">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "useEditorJsField_text"
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "EditorJsField_text"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditMain_hotel",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stars",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "features",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviews",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutLocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userEdited",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "location",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lng",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Text",
      "kind": "LinkedField",
      "name": "descriptionText",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Text",
      "kind": "LinkedField",
      "name": "aboutLocationText",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelEditMainGeneral_hotel"
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};
})();

(node as any).hash = "0c3e4ac74d67ddb5f3eebbaede29b092";

export default node;
